interface ErrorStateProps {
  title?: string;
  body?: string;
  onRetry?: () => void;
}

export function ErrorState({
  title = 'Something went wrong',
  body = 'Try again in a moment.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-box border border-error bg-base-200 p-8 text-center"
      role="alert"
    >
      <div className="text-4xl text-error" aria-hidden="true">
        ⚠
      </div>
      <p className="text-base font-semibold text-base-content">{title}</p>
      <p className="text-sm text-base-content/70">{body}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="btn btn-ghost btn-sm mt-2"
        >
          Retry
        </button>
      )}
    </div>
  );
}
